module.exports = __webpack_public_path__ + "static/media/handshake.a7671fc4.webp";